import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  eyebrowStyles,
  getFillStyles,
  getHeroStyles,
  glyphStyles,
  liveDotStyles,
  pillStyles,
  progressMetaStyles,
  progressRowStyles,
  titleStyles,
  trackStyles,
} from './MilestoneRoadmapHero.styles';

const MilestoneRoadmapHero = ({
  eyebrow,
  currentName,
  statusText,
  strongColor,
  percentage,
  reachedCount,
  total,
  stepNumber,
  daysInProcess = null,
}) => {
  const stepMeta =
    daysInProcess && daysInProcess > 0
      ? `Step ${reachedCount} of ${total} · ${daysInProcess} days in process`
      : `Step ${reachedCount} of ${total}`;

  return (
    <Box sx={getHeroStyles(strongColor)}>
      <Box component="span" sx={glyphStyles}>
        {stepNumber}
      </Box>

      <Typography sx={eyebrowStyles} variant="regular12">
        {eyebrow}
      </Typography>
      <Typography sx={titleStyles} variant="bold24">
        {currentName}
      </Typography>

      <Box sx={pillStyles}>
        <Box sx={liveDotStyles} />
        <Typography variant="medium12">{statusText}</Typography>
      </Box>

      <Box sx={progressRowStyles}>
        <Typography sx={progressMetaStyles} variant="regular12">
          {stepMeta}
        </Typography>
        <Typography variant="bold20">{`${percentage}%`}</Typography>
      </Box>

      <Box sx={trackStyles}>
        <Box sx={getFillStyles(percentage)} />
      </Box>
    </Box>
  );
};

MilestoneRoadmapHero.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  currentName: PropTypes.string.isRequired,
  statusText: PropTypes.string.isRequired,
  strongColor: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  reachedCount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  stepNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  daysInProcess: PropTypes.number,
};

export default MilestoneRoadmapHero;
